// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] + "." + {"506":"80abf42c","536":"22b928bb","889":"e71a1003"}[chunkId] + ".js";
};